import axios from "axios";

class AuthService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_AUTH;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    authenticateUser(username, password) {
        return this.restClient.post('', {
            "username": username, "password": password
        })
    }

}

export default new AuthService();